import { withFeatureFlags } from '@/flags.server';

import { getHomepageProps, type HomepageProps } from '@/components/Homepage/homepageProps.server';

import { resolveHomepageRequest } from '@/utils/tradeRoutes';

export { default } from '@/components/Homepage/HomepagePage';

export const getServerSideProps = withFeatureFlags<HomepageProps>(async (ctx) => {
  const request = resolveHomepageRequest(ctx.query);
  if (request.type === 'redirect') {
    return { redirect: { destination: request.destination, permanent: false } };
  }

  return { props: await getHomepageProps(ctx, request.state) };
});
